import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface ActivityUIState {
  statusFilter: string; // '' = all
  typeFilter: '' | 'Labour' | 'Variation';
  siteIdsFilter: number[];
  fromDate: string;
  toDate: string;
  setStatusFilter: (status: string) => void;
  setTypeFilter: (type: '' | 'Labour' | 'Variation') => void;
  toggleSiteId: (id: number) => void;
  setSiteIds: (ids: number[]) => void;
  setDateRange: (from: string, to: string) => void;
  clearFilters: () => void;
}

export const useActivityUIStore = create<ActivityUIState>()(
  persist(
    set => ({
      statusFilter: '',
      typeFilter: '',
      siteIdsFilter: [],
      fromDate: '',
      toDate: '',
      setStatusFilter: status => set({ statusFilter: status }),
      setTypeFilter: type => set({ typeFilter: type }),
      toggleSiteId: id =>
        set(state => ({
          siteIdsFilter: state.siteIdsFilter.includes(id)
            ? state.siteIdsFilter.filter(x => x !== id)
            : [...state.siteIdsFilter, id],
        })),
      setSiteIds: ids => set({ siteIdsFilter: ids }),
      setDateRange: (from, to) => set({ fromDate: from, toDate: to }),
      clearFilters: () =>
        set({
          statusFilter: '',
          typeFilter: '',
          siteIdsFilter: [],
          fromDate: '',
          toDate: '',
        }),
    }),
    {
      name: 'activity-ui',
      storage: createJSONStorage(() => localStorage),
      // Persist the discrete filter selections so they survive navigation and
      // reloads. The date window is deliberately excluded so Activity opens
      // without hiding older or future bookings.
      partialize: state => ({
        statusFilter: state.statusFilter,
        typeFilter: state.typeFilter,
        siteIdsFilter: state.siteIdsFilter,
      }),
    }
  )
);
